'use client';

import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import { Link } from '@/configurations/i18n/navigation';

/**
 * Rendu quand `page.tsx` appelle `notFound()` (slug inconnu ou malformé).
 * Reprend l'ancien `<NotFoundScreen>` du composant client pour préserver
 * l'UX 404 traduite (heading + message + retour accueil).
 */
export default function DestinationNotFound() {
    const t = useTranslations('destinationDetail.notFound');
    return (
        <Container maxWidth="sm" sx={{ py: 10 }}>
            <Box data-testid="destination-not-found" sx={{ textAlign: 'center', py: 6, px: 4 }}>
                <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
                    {t('heading')}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        mb: 4,
                    }}
                >
                    {t('message')}
                </Typography>
                <Button component={Link} href="/" variant="contained" size="large">
                    {t('backHome')}
                </Button>
            </Box>
        </Container>
    );
}
